<template>
  <div>
    <p>Silent renew</p>
  </div>
</template>

<script>
export default {
  async mounted() {
    this.$auth.handleLogoutRenew()
      .then(() => this.$router.push({ path: '/' }))
      .catch((error) => {
        console.error(error.message);
      });
  },
};
</script>